export const formMessages = {
    required: () => 'Required',
    numeric: () => 'Numbers only',
    objectStructure: () => 'Country object is wrong',
    minLength: () => 'Must be at least 8 characters.',
    isUniquePhoneNumber: () => 'Already in use'
}
